import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { TOTP } from "totp-generator";
import { z } from "zod";
import { Button } from "./components/ui/button";
import { Form, FormField, FormItem, FormLabel } from "./components/ui/form";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "./components/ui/input-otp";

const FormSchema = z.object({
  code: z.string().refine((v) => v.length === 6, {
    message: "Kód musí mít 6 čísel",
  }),
});

export default function AccessBlocker() {
  const form = useForm<z.infer<typeof FormSchema>>({
    mode: "onBlur",
    resolver: zodResolver(FormSchema),
    defaultValues: {},
  });

  const onSubmit = (data: z.infer<typeof FormSchema>) => {
    const { code } = data;
    const secret = "hajkovaalkulacka";
    const result = TOTP.generate(secret);
    if (result.otp !== code) alert("Špatný kód");
    else {
      window.localStorage.setItem("canAccess", "true");
      window.location.reload();
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "hsl(var(--background))",
        zIndex: 1000,
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        textAlign: "center",
        flexDirection: "column",
        padding: "1rem",
      }}
    >
      <div>
        <h2
          style={{
            fontWeight: "bold",
            fontSize: "1.5rem",
          }}
        >
          Předběžný přístup
        </h2>
        <p>
          Tato aplikace je stále v aktivním vývoji a není přístupná veřejnosti.
          <br />
          Pro přístup do aplikace si vyžádejte od autora:
        </p>
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="space-y-4"
            style={{ paddingTop: "1rem" }}
          >
            <FormField
              control={form.control}
              name="code"
              render={({ field }) => (
                <FormItem className="flex flex-col items-center">
                  <FormLabel>Kód</FormLabel>
                  <InputOTP
                    maxLength={6}
                    autoComplete="code"
                    id="code"
                    onChange={(value) => field.onChange(value || null)}
                  >
                    <InputOTPGroup>
                      <InputOTPSlot index={0} />
                      <InputOTPSlot index={1} />
                      <InputOTPSlot index={2} />
                    </InputOTPGroup>
                    <InputOTPSeparator />
                    <InputOTPGroup>
                      <InputOTPSlot index={3} />
                      <InputOTPSlot index={4} />
                      <InputOTPSlot index={5} />
                    </InputOTPGroup>
                  </InputOTP>
                </FormItem>
              )}
            />
            <div>
              <Button
                type="submit"
                className="w-full"
                disabled={!form.formState.isValid}
              >
                Vstoupit
              </Button>
            </div>
          </form>
        </Form>
      </div>
      <a
        style={{
          padding: "0.5rem",
          borderRadius: "0.5rem",
          backgroundColor: "#fff",
          width: "fit-content",
        }}
        href="https://hajas.cz"
        target="_blank"
        rel="noreferrer"
      >
        <img
          src="https://hajas.cz/logo.svg"
          style={{ height: "2.5rem" }}
          alt=""
        />
      </a>
    </div>
  );
}
